import { Controller } from '@hotwired/stimulus'

// <body data-controller="csrf"></body>
export default class extends Controller {
  connect() {
    // bind para conseguir remover os listeners no disconnect
    this.onBeforeCache = this.beforeCache.bind(this)
    this.onRender = this.render.bind(this)
    this.onSubmitEnd = this.updateFromResponse.bind(this)

    document.addEventListener('turbo:before-cache', this.onBeforeCache)
    document.addEventListener('turbo:render', this.onRender)
    document.addEventListener('turbo:submit-end', this.onSubmitEnd)
  }

  disconnect() {
    document.removeEventListener('turbo:before-cache', this.onBeforeCache)
    document.removeEventListener('turbo:render', this.onRender)
    document.removeEventListener('turbo:submit-end', this.onSubmitEnd)
  }

  // 1) evita snapshot com token velho
  beforeCache() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    if (meta) meta.remove()
  }

  // 2) garante um token no <head> logo após render
  render() {
    this.ensureMetaFromForm()
  }

  ensureMetaFromForm() {
    let meta = document.querySelector('meta[name="csrf-token"]')
    if (!meta) {
      const input = document.querySelector('input[name="authenticity_token"]')
      if (input?.value) {
        meta = document.createElement('meta')
        meta.name = 'csrf-token'
        meta.content = input.value
        document.head.appendChild(meta)
      }
    }
  }

  // 3) opcional: se a resposta do servidor trouxer um X-CSRF-Token novo, sincroniza
  updateFromResponse(event) {
    const token = event.detail?.fetchResponse?.response?.headers?.get('X-CSRF-Token')
    if (token) this.writeMeta(token)
  }

  writeMeta(value) {
    let meta = document.querySelector('meta[name="csrf-token"]')
    if (!meta) {
      meta = document.createElement('meta')
      meta.name = 'csrf-token'
      document.head.appendChild(meta)
    }
    meta.content = value
  }
}
